import React, { Suspense, useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { API_URI } from "../Common/data";
import { Helmet } from "react-helmet";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import "./keywordsection.css";
import img3 from "../Assets/dmhb (1).png";
import img4 from "../Assets/dmhb (2).png";
import img5 from "../Assets/Kolkata.png";
import img6 from "../Assets/Chennai.png";
import NewWhy from "../Components/NewWhy.jsx";
import NewServices from "../Components/NewServices.jsx";
import logogif from "../Assets/logogif-optimized.webp";
import { Link, useNavigate } from "react-router-dom";
import HowPvt from "./HowPvt.jsx";
import CircleImg from "../Components/CircleImg.jsx";
import coming from "../Assets/Comming.png";

const Wave = React.lazy(() => import("../Components/Wave"));

function KeywordLandingDetail() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, [slug]);

  const fetchData = async () => {
    try {
      const res = await axios.get(`${API_URI}/keyword-landing/${slug}`);
      setData(res.data.data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  if (loading) return <div className="detail-loading">Loading...</div>;
  if (!data) return <div className="detail-loading">Page Not Found</div>;

  return (
    <>
      <Helmet>
        <title>{data.metaTitle}</title>
        <meta name="description" content={data.metaDescription} />
        <meta name="keywords" content={data.metaKeywords?.join(",")} />
      </Helmet>

      <Navbar />

      <div className="sld1 text-center">
        <h1>{data.heading}</h1>
      </div>

      {/* <section className="keyword-detail-section">
        <div className="keyword-detail-container">
          <h1 className="keyword-detail-heading">{data.heading}</h1>

          <div
            className="keyword-detail-content"
            dangerouslySetInnerHTML={{ __html: data.content }}
          ></div>
        </div>
      </section> */}
      <br />
      <NewWhy />
      <Suspense fallback={null}>
        <Wave />
      </Suspense>
      <NewServices />
      <div className="about-home">
        <div className="about-home-left">
          <p>About Us</p>
          <h2>Cine Celebrate – Best Private theater in Laxmi Nagar</h2>
          <h4>
            At Cine Celebrate, we’ve created a space where celebrations feel
            more personal and truly memorable. Located in Laxmi Nagar, Delhi,
            our private theater offers a refreshing alternative to typical party
            venues. Instead of booking a crowded banquet hall, many people now
            prefer a private theater in Delhi where they can enjoy the big
            screen experience with complete privacy and comfort.
            <br />
            <br />
            Our private screening rooms are used for birthday parties,
            anniversary surprises, romantic movie dates, bride-to-be bashes,
            baby showers, and even small seminars or close gatherings. If you’re
            searching for a private cinema in Delhi NCR, especially around Laxmi
            Nagar, this is where your favourite movie, proposal video, or
            personal memories can be played exclusively for you and your guests.
            <br />
            <br />
            What makes the experience even better is the flexibility. You can
            choose balloon decorations, themed setups, professional photoshoots,
            LED displays, custom on-screen messages, and curated food packages
            based on your celebration style. As one of the decorated private
            venues in Delhi NCR, we focus on keeping everything simple and
            well-organised. From selecting your preferred slot to finalising
            add-ons, our team provides dedicated support throughout the booking
            process.
            <br />
            <br />
            Our theater space is ideal for couples planning a romantic evening,
            families organising a birthday celebration, or groups celebrating
            important milestones. With affordable private theater packages in
            Delhi NCR and flexible options, Cine Celebrate in Laxmi Nagar makes
            it easy to celebrate in a fun, intimate, and stress-free way.
            <br />
            <br />
            Every occasion has a story behind it. We simply give it the screen
            it deserves.
          </h4>
        </div>
        <div className="about-home-right">
          <img
            class=""
            src={logogif}
            alt="Private theater experience preview"
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>

      
      <HowPvt />
      <CircleImg />
      <Footer />
    </>
  );
}

export default KeywordLandingDetail;
